
import { ButtonProps } from "./Button";
import {
  getBaseAppearanceModeVariablesControls,
  is,
  isNot,
  matchProps
} from "@mrocket/styles";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

const match = matchProps<ButtonProps>()

interface ButtonContentProps {
  align: ButtonProps['align'];
  left: boolean;
  right: boolean;
}

export const ButtonContent = styled('div', {
  shouldForwardProp: props => ['children'].includes(props)
})<ButtonContentProps>`
  ${props => props.left && css`padding: 0 10px 0 6px`};
  ${props => props.right && css`padding: 0 6px 0 10px`};
  ${props => !props.right && !props.left && css`padding: 0 10px`};
  width: 100%;
  text-align: ${props => props.align};
`

export const ButtonBeforeContent = styled('div', {
  target: 'before-content'
})<{ singleIcon: boolean }>`
  display: flex;
`
export const ButtonAfterContent = styled('div', {
  target: 'after-content'
})<{ singleIcon: boolean }>`
  display: flex;
`

const keysOfProps = [
  'as',
  'singleIcon',
  'appearance',
  'size',
  'icon',
  'align',
  'stretched',
  'after',
  'before',
  'iconLeft',
  'iconRight',
  'hasMinWidth',
  'progress',
  'mode',
]


export const ButtonRoot = styled('button', {
  shouldForwardProp: props => !keysOfProps.includes(props)
})<ButtonProps & { singleIcon: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  &[disabled],
  &[aria-busy='true'] {
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  }

  &[disabled],
  &::-moz-focus-inner {
    padding: 0;
    border: 0;
  }

  ${is('stretched', css`
    width: 100%;
  `)};
  
  .before-content {
    ${isNot('singleIcon', css`padding-left: var(--sizeBase5)`)};
    // ${isNot('singleIcon', match('size', 'tiny', css`padding-left: var(--sizeBase2)`) as any)};
    // ${isNot('singleIcon', match('size', 'small', css`padding-left: var(--sizeBase3)`) as any)};
  }

  .after-content {
    ${isNot('singleIcon', css`padding-right: var(--sizeBase5)`)};
    // ${isNot('singleIcon', match('size', 'tiny', css`padding-right: var(--sizeBase2)`) as any)};
    // ${isNot('singleIcon', match('size', 'small', css`padding-right: var(--sizeBase3)`) as any)};
  }

  // size
  ${match('size', 'tiny', css`
    height: var(--sizeBase8);
    min-width: var(--sizeBase8);
    font-size: 12px;

    & > div > svg {
      width: 14px;
      height: 14px;
    }
  `)};
  ${match('size', 'small', css`
    height: var(--sizeBase9);
    min-width: var(--sizeBase9);
    font-size: 14px;

    & > div > svg {
      width: 16px;
      height: 16px;
    }
  `)};
  ${({size}) => (!size || size === 'medium') && css`
    height: var(--sizeBase10);
    min-width: var(--sizeBase10);
    font-size: 14px;

    & > div > svg {
      width: 18px;
      height: 18px;
    }
  `};
  ${match('size', 'large', css`
    height: var(--sizeBase11);
    min-width: var(--sizeBase11);
    font-size: 16px;

    & > div > svg {
      width: 24px;
      height: 24px;
    }
  `)};

  min-width: ${({singleIcon, hasMinWidth}) => !singleIcon && hasMinWidth && '90px'};

  &:hover {
    ${props => props.appearance === 'overlay' 
      ? css`background-color: var(--colorFill4Alpha)`
      : css`opacity: 0.85`};
  }
  
  ${props => getBaseAppearanceModeVariablesControls(props.appearance, props.mode, props.radius, props.shadow)};
  
  

 
`
